import { Box, Button, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { isPasswordStrong } from '../Helpers/isPasswordStrong';
import { SignInLayout } from '../Layout/SignInLayout';
import { openAlert } from '../Store/AlertSlice';
import { ChangePassword } from '../firebase/Auth/ChangePassword';

export const PasswordUpdatePage = () => {
    const [currentPass, setCurrentPass] = useState<string>('');
    const [newPass, setNewPass] = useState<string>('');
    const [newPassConf, setNewPassConf] = useState<string>('');
    const dispatch = useDispatch();

    const changeCurrentPassHandler = (
        e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setCurrentPass(e.currentTarget.value);
    };
    const changeNewPassHandler = (
        e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setNewPass(e.currentTarget.value);
    };
    const changeNewPassConfHandler = (
        e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setNewPassConf(e.currentTarget.value);
    };

    const updateButtonDispabled =
        currentPass === '' || newPass === '' || newPassConf === '';

    const updatePassword = () => {
        if (newPass !== newPassConf) {
            dispatch(
                openAlert({
                    displayText: 'Nové heslo se neshoduje s potvrzením',
                    severity: 'error',
                }),
            );
            return;
        }

        if (!isPasswordStrong(newPass)) {
            dispatch(
                openAlert({
                    displayText:
                        'Nové heslo není dostatečně silné. Musí mít: Alespoň 8 znaků, alespoň 1 číslo, alespoň jedno velké písmeno',
                    severity: 'error',
                }),
            );
            return;
        }

        ChangePassword(currentPass, newPass)
            .then((res) => {
                setCurrentPass('');
                setNewPass('');
                setNewPassConf('');
                dispatch(
                    openAlert({
                        displayText: 'Heslo úspěšně změněno.',
                        severity: 'success',
                    }),
                );
            })
            .catch((err) => {
                dispatch(
                    openAlert({ displayText: err.message, severity: 'error' }),
                );
            });
    };

    return (
        <SignInLayout>
            <Typography variant="h4" textAlign="center">
                Změnit heslo
            </Typography>
            <TextField
                label="Aktuální heslo"
                variant="standard"
                type="password"
                color="secondary"
                value={currentPass}
                onChange={changeCurrentPassHandler}
            />
            <TextField
                label="Nové heslo"
                variant="standard"
                type="password"
                color="secondary"
                value={newPass}
                onChange={changeNewPassHandler}
            />

            <TextField
                label="Potvrzení nového hesla"
                variant="standard"
                type="password"
                color="secondary"
                value={newPassConf}
                onChange={changeNewPassConfHandler}
            />
            <Box style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                    color="secondary"
                    variant="contained"
                    sx={{ width: '100px' }}
                    onClick={updatePassword}
                    disabled={updateButtonDispabled}
                >
                    <Typography variant="button" sx={{ fontWeight: 'bold' }}>
                        Změnit
                    </Typography>
                </Button>
            </Box>
        </SignInLayout>
    );
};
